<script >
import { getEntity } from '../../utils';
import { computed, inject } from 'vue-demi';
import { FAModuleWrapper } from '@futuweb/community-activity-modules/lib/vue2/module-wrapper/index.es.js';
import { BaseConfigKey } from '@futuweb/community-activity-modules/lib/vue2/provider-config/index.es.js';
import { EMPTY_CONTENT_STATUS } from '@futuweb/community-activity-modules/lib/constants/empty-content-status.js';
import { SKIN_NUM, SKIN } from '../../constants/index';
import { LANG_NUM_MAP } from '../../constants/i18n';
import i18n from './i18n.js';
import QACardNew from '../../components/QACardNew/index.vue';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
const __sfc_main = {};
__sfc_main.props = {
  language: String,
  moduleStatus: Number,
  info: {
    type: Object,
    default: () => ({})
  },
  baseInfo: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
  });
  const baseConfig = inject(BaseConfigKey);
  const props = __props;
  const langMap = computed(() => {
    return i18n.messages[props.language];
  });
  const activity = computed(() => {
    return props.info.activity;
  });
  const activityTime = computed(() => {
    const {
      startTime,
      endTime
    } = activity.value;
    return {
      startTime: toolDateFormatter.dateFormatByTemplate({
        dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
        timestamps: startTime * 1e3,
        lang: LANG_NUM_MAP[props.language]
      }),
      endTime: toolDateFormatter.dateFormatByTemplate({
        dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
        timestamps: endTime * 1e3,
        lang: LANG_NUM_MAP[props.language]
      })
    };
  });
  const list = computed(() => {
    return props.info.data || [];
  });
  const qaList = computed(() => {
    if (!list.value.length) {
      return [];
    }
    // 取最后一个元素
    return list.value.slice(list.value.length - 1, list.value.length);
  });
  const skinStr = computed(() => {
    const skinNum = baseConfig.value.skin;
    if (skinNum === SKIN_NUM[SKIN.BLACK]) {
      return SKIN.BLACK;
    }
    return SKIN.WHITE;
  });
  const emit = __ctx.emit;
  function onClickRule() {
    emit('clickRule');
  }
  function onClickMore() {
    emit('clickMore');
  }
  return {
    EMPTY_CONTENT_STATUS,
    props,
    langMap,
    activity,
    activityTime,
    list,
    qaList,
    skinStr,
    onClickRule,
    onClickMore
  };
};
__sfc_main.components = Object.assign({
  FAModuleWrapper,
  QACardNew
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <FAModuleWrapper
        v-if="
            [EMPTY_CONTENT_STATUS.LOADING, EMPTY_CONTENT_STATUS.SUCCESS].includes(props.moduleStatus)
            && (qaList.length || activity)
        "
        :title="langMap['企业问答']"
        :moduleName="langMap['企业问答']"
        :moduleStatus="props.moduleStatus"
    >
        <div
            :class="['qa-container', skinStr]">
            <!-- 问答活动时间 -->
            <div class="qa-activity" v-if="activity">
                <h3 class="qa-activity-title">{{ activity.introduce }}</h3>
                <div class="qa-activity-time">{{ langMap['活动时间'] }}: {{ activityTime.startTime }}～{{ activityTime.endTime }}</div>
                <a
                    class="qa-activity-link"
                    v-if="activity.rule"
                    @click="onClickRule()"
                >{{ langMap['了解规则'] }}</a>
            </div>
            <!-- 问答列表 -->
            <div class="qa-wrap">
                <div class="qa-list" v-if="qaList.length">
                    <QACardNew
                        v-for="(item, index) in qaList"
                        :key="index"
                        :info="item"
                        :baseInfo="baseInfo"
                        :language="language"
                    />
                </div>
            </div>
            <!-- 不处理查看更多的具体逻辑，跳转至站内财报页 -->
            <div class="more-wrap" v-if="list.length > 1">
                <a
                    class="more-btn"
                    href="javascript:;"
                    @click="onClickMore()"
                >{{ langMap['查看更多问答'] }}<svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 0.5L8 4L4 7.50001" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
            </div>
        </div>
    </FAModuleWrapper>
</template>
<style lang="less" scoped>
.qa-container {
    margin-top: 0.32rem;
    padding-bottom: 0.48rem;
    .qa-activity {
        &-title {
            font-weight: 400;
            line-height: 0.4rem;
            font-size: 0.32rem;
        }

        &-time {
            margin-top: 0.1rem;
            line-height: 0.32rem;
            font-size: 0.24rem;
        }

        &-link {
            margin-top: 0.12rem;
            display: block;
            line-height: 0.32rem;
            font-size: 0.24rem;
        }
    }

    .qa-wrap {
        padding-right: 0.8rem;
    }

    .more-wrap {
        margin-top: 0.16rem;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        .more-btn {
            font-size: 0.24rem;
            line-height: 0.24rem;
            svg {
                display: inline-block;
                margin-left: 0.04rem;
                width: 0.16rem;
                height: 0.16rem;
            }
        }
    }

    &.white {
        .qa-activity {
            &-title {
                color: #0F1112;
            }

            &-time {
                color: #606266;
            }

            &-link {
                color: #2B78F5;
            }
        }
        .more-wrap {
            .more-btn {
                color: #909499;
                svg {
                    path {
                        stroke: #909499;
                    }
                }
            }
        }
    }

    &.black {
        .qa-activity {
            &-title {
                color: #E3E4E5;
            }

            &-time {
                color: #9B9B9E;
            }

            &-link {
                color: #4E7FCE;
            }
        }
        .more-wrap {
            .more-btn {
                color: #7D7F83;
                svg {
                    path {
                        stroke: #7D7F83;
                    }
                }
            }
        }
    }
}
</style>
